import { TMobileSignupForm } from './form';
import { useMobileSignupPersistence } from './persistence';
import {
  usePostApplicationMutation,
  usePostStateMutation,
} from '../../../api/lendingApi/lendingApiMutations';
import { useGetApplicationQuery } from '../../../api/lendingApi/lendingApiQueries';
import { getInitialApplicationBodyDE } from '../../../helpers/getApplicationBody';
import { getReferralSession } from '../../../helpers/referralSession';
import { useSignupParams } from '../../../hooks/useSignupParams';
import { TGetStartedDataDE } from '../../GetStarted/GetStartedDE/GetStartedDE';
import { getInitialStateBody } from '../../GetStarted/GetStartedUK/GetStartedUK.helpers';

// Email step: mints the account first pass, PUTs the updated loan request on later passes (back-nav edits).
export const useMobileSignupAccountSetup = () => {
  const { affiliateTag, fromCampaign } = useSignupParams();
  const { application } = useGetApplicationQuery();
  const { putGetStartedStage } = useMobileSignupPersistence();
  const { mutatePostState } = usePostStateMutation();
  const { mutatePostApplication } = usePostApplicationMutation();

  const setUpAccount = async (form: TMobileSignupForm) => {
    if (application) {
      await putGetStartedStage(form);
      return;
    }

    const newStateKey = await mutatePostState({
      body: getInitialStateBody(affiliateTag, fromCampaign, {
        email: form.email,
      } as TGetStartedDataDE),
    });
    if (!newStateKey) throw new Error('POST state returned no state_key');

    await mutatePostApplication({
      stateKey: newStateKey,
      body: getInitialApplicationBodyDE(
        affiliateTag,
        {
          amount: form.amount,
          loanDuration: form.loanDuration || undefined,
          loanPurpose: form.loanPurpose || undefined,
          loanPurposeDetails: form.loanPurposeDetails,
        },
        getReferralSession(),
      ),
    });
  };

  return { setUpAccount };
};
